module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"blueimp-load-image/js/load-image.all.min","commonjs":"blueimp-load-image/js/load-image.all.min","commonjs2":"blueimp-load-image/js/load-image.all.min","root":"loadImage"}
 ** module id = 3
 ** module chunks = 0 1
 **/